import * as React from "react";
import {observer} from "mobx-react";
import type {IToggleContainerProps} from "./ToggleContainer";
import {ToggleContainer} from "./ToggleContainer";

interface IInteractiveToggleContainerProps<T> extends IToggleContainerProps<T> {
	readonly isEnabled: boolean;
	readonly onEnabledChange: (value: boolean) => void;
}

@observer
export class InteractiveToggleContainer<T = any> extends React.PureComponent<IInteractiveToggleContainerProps<T>> {
	public override render() {
		const {title, children, open, onToggleOpen, onAddClick, className, isEnabled, onEnabledChange} = this.props;
		const props = {title, children, open, onToggleOpen, onAddClick, className, isEnableTogglerVisible: true, isEnabled, onEnabledChange};

		return <ToggleContainer {...props} />;
	}
}
